import type { ColoredBadgeColor } from '@ipen/components';

import { useTypedConfig } from '@ipen-portal/plugin-common-react';
import { ColoredBadge, SidebarBrand } from '@ipen/components';
import { Link } from 'react-router-dom';

import type { Config as TConfig } from '../../../../config';

import classes from './BackstageSidebarLogo.module.css';

const ENVIRONMENT_BADGES: Record<string, { badgeColor: ColoredBadgeColor; badgeContent: string }> = {
  dev: { badgeColor: 'warning', badgeContent: 'DEV' },
  qas: { badgeColor: 'info', badgeContent: 'QAS' },
  run: { badgeColor: 'success', badgeContent: 'NEXT' },
};

type Props = {
  className?: string;
};

export const BackstageSidebarLogo = ({
  className,
}: Props) => {
  const config = useTypedConfig<TConfig>();
  const environment = config.getOptional('app.environment');
  const badge = environment ? ENVIRONMENT_BADGES[environment] : undefined;

  return (
    <div className={classes.root}>
      <SidebarBrand
        className={className}
        component={Link}
        to="/"
      />
      {badge && (
        <ColoredBadge className={classes.badge} color={badge.badgeColor} size="small">
          {badge.badgeContent}
        </ColoredBadge>
      )}
    </div>
  );
};
